<template lang="pug" src="./accessControl.pug"></template>

<script>
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'
// import { localize } from 'vee-validate'
import { buildPayloadPagination } from '@/utils/utils.js'
import VipDevice from './VipDevice'

export default {
  components: {
    VipDevice
  },
  data () {
    return {
      releaseDialog: false,
      itemRelease: [],
      tab: null,
      vips: true,
      pagination: {
        identity: window.localStorage.getItem('selectedHotspot').split('"').join(''),
        sortBy: ['nome'],
        sortDesc: ['true']
      },
      fieldsToSearch: ['nome', 'email'],
      dataTableLoading: true,
      search: '',
    }
  },
  computed: {
    headers() {
      if(this.vips){
        return [
          {
            text: `${this.$t('adminconnections.TABLEUSERNAME')}`,
            align: 'left',
            value: 'nome',
          },
          { text: 'Email', value: 'email' }
        ]
      }else{
        return [
          {
            text: `${this.$t('adminconnections.TABLEUSERNAME')}`,
            align: 'left',
            value: 'nome',
          },
          { text: 'Email', value: 'email' },
          { text: 'Telefone', value: 'telefone' },
          { text: `${this.$t('adminaccess.RELEASEACTION')}`, value: 'actions' }
        ]
      }
    },
    vipItems(){
      return this.$store.state.adminAccess.vips
    },
    totalVipItems(){
      return this.$store.state.adminAccess.totalVips
    },
    blockedItems(){
      return this.$store.state.adminAccess.blockeds
    },
    totalBlockedItems(){
      return this.$store.state.adminAccess.totalBlockeds
    },
    selectedHs () {
      return this.$store.state.adminHotspots.selectedHotspot
    }
  },
  methods: {
    ...mapGetters(['isTokenSet']),
    ...mapActions(['getVipDevices', 'getBlockedDevices', 'blockUserAccess']),
    confirmRelease(item){
      this.releaseDialog = true
      this.itemRelease = item
    },
    async releaseUser(){
      this.releaseDialog = false
      await this.blockUserAccess({
        identity: window.localStorage.getItem('selectedHotspot').split('"').join(''),
        userId: this.itemRelease._id,
        block: false
      })
      this.doSearch()
    },
    showVips(vip){
      this.vips = vip
      this.doSearch()
    },
    async doSearch() {
      try {
        this.dataTableLoading = true

        if(this.vips){
          await this.getVipDevices(
            window.localStorage.getItem('selectedHotspot').split('"').join(''),
            buildPayloadPagination(this.pagination, this.buildSearch())
          )
        }else{
          await this.getBlockedDevices(
            window.localStorage.getItem('selectedHotspot').split('"').join(''),
            buildPayloadPagination(this.pagination, this.buildSearch())
          )
        }

        this.dataTableLoading = false
        // eslint-disable-next-line no-unused-vars
      } catch (error) {
        console.log(error)
        this.dataTableLoading = false
      }
    },
    buildSearch() {
      console.log('Search: '+this.search
        ? { query: this.search, fields: this.fieldsToSearch.join(',') }
        : {})
      return this.search
        ? { query: this.search, fields: this.fieldsToSearch.join(',') }
        : {}
    }
  },
  watch: {

    selectedHs () {
      this.doSearch()
    },
    // lang (newLang) { // se trocou a linguagem, revalida o form
    //   const lg = { en: en, pt: pt_BR, es: es };
    //   localize(`${newLang}`, lg[newLang]);
    // },

    pagination: {
    async handler() {
      this.doSearch()
    },
    deep: true
    },
    search() {
      clearTimeout(this.delayTimer)
      this.delayTimer = setTimeout(() => {
        this.doSearch()
      }, 400)
    }
  }

}
</script>
